export default __webpack_public_path__ + "static/media/default.b8590b18.wav";